export default{

	init(){

		var app = new Vue({
			el: '#navComponent',

			data: {
				open: false
			},

			mounted(){
				EventBus.$on('closeNavigation', this.check)
			},

			methods: {

				check(){
					if (this.open) {
						this.open = false
					}
				},

				toggleOpen(){
					this.open = true
				},

				panelEnter(el, done){
					var tl = new TimelineMax({onComplete: function(){ done(); }});
					tl.fromTo(document.querySelector('.navicon-btn'), .2, {opacity: 1}, {opacity: 0, display: 'none', ease: Power2.easeOut})
					tl.fromTo(document.querySelector('#navComponent .navigation-panel'), .4, {x: '100%'}, {x:'0%', ease: Power2.easeOut})
					tl.fromTo(document.querySelector('.navigation-overlay'), .4, {opacity: 0, display: 'none'}, { opacity: 1, display: 'block', ease: Power2.easeOut}, .2)
					tl.fromTo(el, .2, {width: 0}, {width: 400, ease: Power2.easeOut}, 0)
					tl.fromTo(document.querySelector('.navigation-panel-logo'), .4, {opacity: 0, display: 'none'}, { opacity: 1, display: 'block', ease: Power2.easeOut}, .2)
					tl.staggerFromTo(el.querySelectorAll('ul'), .3, {display: 'none', y: 20, opacity: 0}, {y: 0, opacity: 1, display: 'block', ease: Power2.easeOut})
				},

				panelLeave(el, done){
					var tl = new TimelineMax({onComplete: function(){ done(); }});
					var calcWidth = document.querySelector('#navComponent .navigation-panel').clientWidth - 50
					tl.staggerFromTo(el.querySelectorAll('ul'), .3, {display: 'block', y: 0, opacity: 1}, {y: 20, opacity: 0, display: 'none', ease: Power2.easeOut})
					tl.fromTo(document.querySelector('.navigation-panel-logo'), .4, {opacity: 1, display: 'block'}, { opacity: 0, display: 'none', ease: Power2.easeOut}, .2)
					tl.fromTo(document.querySelector('.navigation-overlay'), .4, {opacity: 1, display: 'block'}, { opacity: 0, display: 'none', ease: Power2.easeOut}, .2)
					tl.fromTo(document.querySelector('#navComponent .navigation-panel'), .4, {x: '0%'}, {x:calcWidth, ease: Power2.easeOut})
					tl.fromTo(document.querySelector('.navicon-btn'), .2, {opacity: 0}, {opacity: 1, display: 'block', ease: Power2.easeOut})
					tl.fromTo(el, .2, {width: 400}, {width: 0, ease: Power2.easeOut})
				}
			}
		})



	}


}